import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';
import { FeedbackSurveyQuestion } from '../models';


const KEY_ACTION = ActionType.AddQuestionRequest;
const ACTIONS    = [
  ActionType.AddQuestionRequest,
  ActionType.AddQuestionResponse,
  ActionType.AddQuestionError,
];


type Payload = FeedbackSurveyQuestion;

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to add a dev plan item
 */
export const addQuestionAction = (
  projectId: number,
  participantId: number,
  questionId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.AddQuestion,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    projectId:     projectId,
    participantId: participantId,
    questionId:  questionId,
    languageId: state.locale.lang.languageId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['selectedQuestions', `${action.meta.projectId}`],
    (successState.selectedQuestions?.[`${action.meta.projectId}`] || []).concat(payload),
    successState,
  );
};


export const addQuestionReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
